//to add to html project
$('.video-container').on("click",
    function (e) {
        e.preventDefault();
        var imgURL = $(this).find("img").attr('src');
        var rx = /\/vi\/([^\/]+)/
        var arr = rx.exec(imgURL);
        var ver = $(this).find("a").attr('href').split('v=');
        var url = "";
        if (ver[1] != undefined) {
            url = "//www.youtube.com/embed/" + ver[1] + "?rel=0&autoplay=1&showinfo=0";
            $(this).find("img").hide();
            $(this).append('<iframe class="back-img" height="169" src="' + url + '" frameborder="0" allowfullscreen></iframe>');
        }
    }

);

function play_video(videolink) {
    $(videolink).parent().parent().parent().find("div.video-card").click();
}
$('.video-link-a').click(function () { play_video(this); return false; });

//to add to html project
$('.btnSwitchToOtherLang').on("click", function () {
    {
        $(".pOtherLang").show(); $(".english").hide();
        if ($('a.continue-read')) {
            $('a.continue-read').hide();
        }

    }
});
$('.btnSwitchtoEnglish').on("click", function () {
    {
        $(".pOtherLang").hide(); $(".english").show();
        if ($('a.continue-read')) {
            $('a.continue-read').show();
        }

    }
});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};

$(document).ready(function () {
    var lang = getUrlParameter('lang');
    if (lang != null) {
        if (lang == "spanish") {
            if ($(".pOtherLang").text().length > 0) {
                $(".pOtherLang").removeClass("hidden");
                $(".english").addClass("hidden");
            }
        }
    }
});

$('.video-card').click(function (e) {
    if ($(window).width() < 1025) {
        video_card_height();
    }
    var vid = $(this).find('.video').data('vid').split('v=');
    var yt_embed = '<div class="player"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + vid[1] + '?rel=0&autoplay=1&showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
    $(this).find('.video').html(yt_embed);
    e.preventDefault();
});
$('.vimeo-thumbnail').click(function (e) {
    //if ($(window).width() < 1025) {
    //    video_card_height();
    //}
    $(this).hide();
    $(this).parent().find('.vimeo-video').show();
    var vid = $(this).parent().find('.vimeo-video').data('vid');
    var yt_embed = ' <iframe class="vimeo-iframe" src=' + vid + ' frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title=""></iframe>';

    $(this).parent().find('.vimeo-video').html(yt_embed);
    $(this).parent().find('.vimeo-video').show();
    e.preventDefault();
});

$(window).on('resize', function () {
    if ($(".video-card").length > 0) {
        $('.video-card').height('auto');
        video_card_height();
    }
});

function video_card_height() {
    // console.log('called: video_card_height()');
    var heights = $('.video-card').map(function () {
        return $(this).height();
    }).get(), maxHeight = Math.max.apply(null, heights);
    $('.video-card').height(maxHeight);
}

//$(document).ready(function () {
//  var video = document.getElementById('ourVideo');
//  video.addEventListener('click',function(){
//     video.play();
//   },false);
//});

$('ul.pdfs').each(function () {

    var LiN = $(this).find('li.pdf').length;
    var x = $(this).find('#pdfshow').val();
    $(this).find('li.pdf:lt(' + x + ')').show();
    if (LiN > 3) {
        $(this).parent().find('.liShowMore').removeClass("hidden");
    }
});


$('ul.pdfs').on('click', '.showmore', function () {
    var LiN = $(this).parent().parent().find('li.pdf').length;
    var x = parseInt($(this).parent().parent().find('#pdfshow').val());
    x = (x + 3 <= LiN) ? x + 3 : LiN;
    $(this).parent().parent().find('#pdfshow').val(x);
    $(this).parent().parent().find('li.pdf:lt(' + x + ')').show();

    if (x == LiN) {
        $(this).parent().addClass("hidden");
        $(this).parent().parent().find('.liShowLess').removeClass("hidden");
    }
    else {
        $(this).parent().parent().find('.liShowLess').removeClass("hidden");
    }
});

$('ul.pdfs').on('click', '.showless', function () {
    var x = parseInt($(this).parent().parent().find('#pdfshow').val());
    x = (x - 3 < 3) ? 3 : x - 3;
    $(this).parent().parent().find('li.pdf').not(':lt(' + x + ')').hide();
    $(this).parent().parent().find('#pdfshow').val(x);
    if (x <= 3) {
        $(this).parent().addClass("hidden");
        $(this).parent().parent().find('.liShowMore').removeClass("hidden");
    }
    else {
        $(this).parent().parent().find('.liShowMore').removeClass("hidden");
    }
});


